/**
 * @generated SignedSource<<86d74ed317b80f5877b35c043fa692bb>>
 * @relayHash 19489f2f8a9baab059563e960c798b2c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8fab195964e776fd865492087c30ec5c11be511a4944a8e3c669092f54ba72ae

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GoalPanelQuery$variables = {
  ari: string;
};
export type GoalPanelQuery$data = {
  readonly townsquare: {
    readonly goal: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = [
  {
    "concreteType": "TownsquareQueryApi",
    "kind": "LinkedField",
    "name": "townsquare",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          }
        ],
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goal",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "8fab195964e776fd865492087c30ec5c11be511a4944a8e3c669092f54ba72ae",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f64aa08bbb50f7bef57ecdfe9cf80030";

export default node;
